import { useEffect } from "react";

const useInlineScript = (ref: React.RefObject<HTMLElement>, html: string) => {
  useEffect(() => {
    const node = document.createRange().createContextualFragment(html);
    if (ref.current) {
      ref.current.appendChild(node);
    }

    return () => {
      if (ref.current) {
        ref.current.textContent = "";
      }
    };
  }, [ref, html]);
};

export default useInlineScript;
